import React from 'react';
import Header from "./header";
import Footer from "./footer";
import { connect } from "react-redux";


class PageNotFound extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userType: "",
            profileName: "",

        }
    }

    homeRoute = () => {
          switch (this.state.userType) {

            case "patient":
                this.props.history.push("/PatientHome");
                break;
            case "facility":
                this.props.history.push("/FacilityHome");
                break;
            case "admin":
                this.props.history.push("/AdminHome");
                break;
            case "employee":
                this.props.history.push("/EmployeHome");
                break;
            case "other":
                this.props.history.push("/PatientHome");
            break;
            default:
            break;
        }
    }
    componentDidMount() {
        if (this.props.profileDetails) {
            let userType = this.props.profileDetails.commonUser.userType;
             this.setState({
                userType,
             })
        }
    }

    render() {
        return (
            <>
            <Header   />
            <div className="container no-page">
                <img src="images/404-page.png" />
                {this.state.userType &&
                <div className="back-btn">
                    <button onClick={this.homeRoute}>Go Home</button>
                </div>
                }
                {!this.state.userType &&
                <div className="back-btn">
                    <button onClick={()=>{this.props.history.push("/login")}}>Go Login</button>
                </div>
                }
            </div>
            <Footer />
            </>
        )
    }
}

 const mapStateToProps = state => ({
    profileDetails: state.commonReducer.profileDetails,
});
 

export default connect(
    mapStateToProps,
    null
) (PageNotFound);